import { acceptHMRUpdate, defineStore } from 'pinia';

import { CompanyDto } from '../interfaces/company.dto';
import companyService from '../services/company.service';

export const useCompanyStore = defineStore({
  id: 'company',
  state: (): {
    company: CompanyDto | null;
    isLoading: boolean;
    isLoaded: boolean;
  } => ({
    company: null,
    isLoading: false,
    isLoaded: false,
  }),
  getters: {
    aptlyFeedUrl: (state): string | null => {
      return state.company?.integrations?.aptly?.feedUrl ?? null;
    },
    isAptlyConnected: (state): boolean => {
      return !!state.company?.integrations?.aptly?.feedUrl;
    },
  },
  actions: {
    async load(): Promise<void> {
      if (this.isLoaded && !this.isLoading) {
        return;
      }

      this.isLoading = true;
      try {
        this.company = await companyService.loadCompany();
        this.isLoaded = true;
      } catch (error) {
        console.error('Failed to load company:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    async refresh(): Promise<void> {
      this.isLoaded = false;
      await this.load();
    },

    /** Sync the cache after update endpoints that return the fresh CompanyDto */
    setCompany(company: CompanyDto): void {
      this.company = company;
      this.isLoaded = true;
    },

    $reset() {
      this.company = null;
      this.isLoading = false;
      this.isLoaded = false;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCompanyStore, import.meta.hot));
}
